import { Controller } from '@hotwired/stimulus';

const STORAGE_KEY = 'sidebar:collapsed';

export default class extends Controller {
  static targets = ['mobile', 'overlay'];

  toggleCollapsed() {
    const html = document.documentElement;
    const next = html.dataset.sidebarCollapsed === 'true' ? 'false' : 'true';
    html.dataset.sidebarCollapsed = next;
    localStorage.setItem(STORAGE_KEY, next);
  }

  toggle() {
    if (this.mobileTarget.classList.contains('-translate-x-full')) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.overlayTarget.classList.remove('hidden');
    this.mobileTarget.classList.remove('hidden');
    this.mobileTarget.offsetHeight;
    this.mobileTarget.classList.remove('-translate-x-full');
    this.mobileTarget.classList.add('translate-x-0');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${window.scrollY}px`;
  }

  close() {
    const scrollY = document.body.style.top;
    this.mobileTarget.classList.remove('translate-x-0');
    this.mobileTarget.classList.add('-translate-x-full');
    this.overlayTarget.classList.add('hidden');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}
